import { UseControllerProps, useController } from 'react-hook-form';

import { cn } from '@/lib/utils';

import { DigiInput } from './digi-input';

interface DigiInputFieldProps extends UseControllerProps {
  label: string;
  labels?: string[];
  labelClassName?: string;
  className?: string;
}

export const DigiInputField = ({
  label,
  labels,
  labelClassName,
  className,
  ...props
}: DigiInputFieldProps & Omit<React.ComponentProps<typeof DigiInput>, 'value' | 'onChange'>) => {
  const {
    field: { onChange, value },
    fieldState: { error },
  } = useController(props);
  return (
    <div className={cn('flex flex-col gap-2', className)}>
      {label && (
        <label className={cn('sky-mark-bold-16 text-primary-midnight', labelClassName)}>
          {label}
        </label>
      )}
      <DigiInput value={value} labels={labels} onChange={onChange} {...props} error={!!error} />
      {error && <p className="sky-mark-regular-14 text-secondary-red">{error.message}</p>}
    </div>
  );
};
